import { render, staticRenderFns } from "./ProcessesTable.vue?vue&type=template&id=2b3b0de3&scoped=true"
import script from "./ProcessesTable.vue?vue&type=script&lang=js"
export * from "./ProcessesTable.vue?vue&type=script&lang=js"
import style0 from "./ProcessesTable.vue?vue&type=style&index=0&id=2b3b0de3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3b0de3",
  null
  
)

export default component.exports